import { render, staticRenderFns } from "./ToolbarNotification.vue?vue&type=template&id=3e1f18db&"
import script from "./ToolbarNotification.vue?vue&type=script&lang=js&"
export * from "./ToolbarNotification.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports